import script from "./LKProjectWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./LKProjectWindow.vue?vue&type=script&setup=true&lang=js"

import "./LKProjectWindow.vue?vue&type=style&index=0&id=3fd6b31b&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fd6b31b"]])

export default __exports__